import { Injectable, NgZone } from '@angular/core';

import { Subject } from 'rxjs';

import { EventSourcePolyfill } from 'ng-event-source';

import { Notification } from '../../sanus/notifications/models/notification.model';
import { EventSourceObj } from '../models/sse.model';

import { TokenService } from './token/token.service';

@Injectable({
	providedIn: 'root',
})
export class SseService {
	message$: Subject<Notification> = new Subject();

	sources: EventSourceObj[] = [];

	constructor(
		private readonly ngZone: NgZone,
		private readonly token: TokenService,
	) {}

	attachEventSourceListener(idx: number): void {
		this.sources[idx].es.onmessage = (m) => {
			this.ngZone.run(() => {
				const notification = JSON.parse(m.data) as Notification;
				this.message$.next(notification);
			});
		};
	}

	closeEventSources(): void {
		for (const source of this.sources) {
			source.es.close();
		}
		this.sources = [];
	}

	startEventSource(url: string): void {
		const token = this.token.getToken();

		if (token.length) {
			this.sources.push({
				es: new EventSourcePolyfill(url, {
					headers: {
						Accept: 'text/event-stream',
						Authorization: `Bearer ${token}`,
					},
				}),
				url,
			});
			this.attachEventSourceListener(this.sources.length - 1);
		}
	}
}
